import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=94b1bd64&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b1bd64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b1bd64')) {
      api.createRecord('94b1bd64', component.options)
    } else {
      api.reload('94b1bd64', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=94b1bd64&scoped=true&", function () {
      api.rerender('94b1bd64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Terms.vue"
export default component.exports